import { useState } from 'react';

export const useSpeechToText = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const transcribe = async (audioBlob: Blob, language: string): Promise<string | null> => {
    setLoading(true);
    setError(null);
    
    console.log("Iniciando transcripción externa para:", language);

    const formData = new FormData();
    formData.append('file', audioBlob, 'audio.mp3'); 

    let isoLanguage = 'en';
    if (language === 'german') isoLanguage = 'de';
    else if (language === 'french') isoLanguage = 'fr';
    else if (language === 'spanish') isoLanguage = 'es';

    formData.append('language', isoLanguage);

    try {
      const response = await fetch("/transcribe.php", {
        method: "POST",
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      setLoading(false);
      return data.text;

    } catch (err: any) {
      console.error("Error en hook useSpeechToText:", err);
      setError(err.message);
      setLoading(false);
      return null;
    }
  };

  return { transcribe, loading, error };
};